import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';

class Oar extends Component {

  onLink() {
    //window.location.href = "https://goo.gl/forms/hurdo5Z7VR19Q6GY2";

    let data = this.props.data
    let access_id = data["access id"];

    this.props.changeRoute("/console/oarreport?id="+access_id)
  }
  render(){
    const { classes, theme, location, data } = this.props;

    return(
      <div className={classes.root}>
        <Typography onClick={() => this.onLink()}  className={classes.textColor} type="subheading" color="primary">
          OAR
        </Typography>
        <Typography type="subheading" color="secondary">
           {data["4b OAR Post ranking"]}
        </Typography>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    changeRoute: (url) => dispatch(push(url)),
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(null,mapDispatchToProps)(Oar)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Home/scenes/MultifolderView/components/User/components/Oar/index.js